import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  img: 'https://cdn.magicpatterns.com/uploads/ssinKMKxXdSSe7EcwRZX35/BONO_1.png',
  title: 'Bono 1 - Plantillas para practicar',
  desc: 'Ejercicios de líneas, curvas, contornos, rellenos, transparencias y combinaciones de color para ganar confianza antes de pintar una pieza final.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/v6hLHzna7GrxXRu3JfGuHZ/BONO_2.png',
  title: 'Bono 2 - +100 plantillas listas para imprimir',
  desc: 'Diseños listos para usar en piezas de falso vitral: mandalas, flores, mariposas, corazones, aves, gatos, diseños deco, infantiles y fechas especiales.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/h3AtYqeR1NBra3ZhfojvR3/BONO_3.png',
  title: 'Bono 3 - +100 ideas para vender',
  desc: 'Inspiración para crear portavelas, frascos, cuadros, fanales, atrapasoles, souvenirs, sets de regalo, decoración para el hogar y piezas personalizadas.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/bGFqUhtCyXdZUfpxyWFtR2/BONO_4.png',
  title: 'Bono 4 - Guía de emprendimiento',
  desc: 'Aprendé a elegir productos para vender, calcular costos, poner precios, armar combos, sacar fotos, vender por Instagram y WhatsApp, tomar pedidos y aprovechar fechas especiales.'
}];
export function Bonuses() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-bg relative overflow-hidden" data-id="element-30" data-mp="3n5ohq23rxwf2">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-deco-sage/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-31" data-mp="2ugqzu03h61mu"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-deco-terra/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-32" data-mp="38hbhuu1kftfa"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-33" data-mp="33ja14frm466z">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-34" data-mp="nozyyrd6ka94">
          <div className="inline-flex items-center justify-center gap-2 bg-deco-card text-deco-terra px-5 py-2 rounded-full font-bold text-xs sm:text-sm mb-6 border border-deco-terra/20 shadow-sm" data-id="element-35" data-mp="ir6t5zfshi9d">
            <Gift size={16} data-id="element-36" data-mp="3hhr9lqj2l62q" />
            <span className="uppercase tracking-wider" data-id="element-37" data-mp="3hgyb1cu9lmvo">
              Bonos incluidos solo por hoy
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" data-id="element-38" data-mp="3lhi68ava2gf6">
            Además, te llevás recursos extra
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-39" data-mp="2ttgc8xcl1oj7">
            Para practicar, crear más diseños y empezar a vender tus piezas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 mb-10 max-w-5xl mx-auto" data-id="element-40" data-mp="32slae2k8ffuu">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-[2rem] overflow-hidden shadow-md border border-deco-warm flex flex-col hover:shadow-lg transition-all duration-300" data-id="element-41" data-mp="37legouvcmw91" data-mpi={i}>
              <div className="w-full aspect-[3/4] sm:aspect-square relative bg-deco-warm/30" data-id="element-42" data-mp="22iu09eyh5rvj">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-43" data-mp="1xk0p3t6nucyj" />
              </div>
              <div className="p-6 sm:p-8 flex flex-col flex-1" data-id="element-44" data-mp="1tmkz9vuuml7a">
                <h3 className="text-lg sm:text-xl font-serif font-bold text-deco-text mb-3" data-id="element-45" data-mp="1omq9xwqq23oc">
                  {bonus.title}
                </h3>
                <p className="text-deco-text/80 text-sm sm:text-base leading-relaxed" data-id="element-46" data-mp="1evc7bg3h4nqz">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto" data-id="element-47" data-mp="15uo0b5chznnl">
          
        </motion.div>
      </div>
    </section>;
}